module.exports = __webpack_public_path__ + "public/img/pic.27a136c3.png";